import * as React from "react";
import { Component } from "react";
import { Redirect } from "react-router";
import LoadingStatus from "src/components/common/LoadingStatus";
import AccountForm from "src/components/projects/project/accounts/AccountForm";
// import "../../../../css/components/projects/project/accounts/accountform.css";
import fs from "../../../../services/config/fbConfig";
import { IAccount, IAccountPageProps, IAccountPageState } from "./interfaces";

export default class AccountPage extends Component<IAccountPageProps, IAccountPageState> {
  private projectDocument: firebase.firestore.DocumentReference;
  public constructor(props: IAccountPageProps) {
    super(props);

    this.state = {
      loading: true,
      accountHolder: "",
      accountNumber: "",
      address: "",
      cityState: "",
      nameKey: "",
      saving: false,
      serviceReference: "",
    };

    this.handleAccountHolderChanged = this.handleAccountHolderChanged.bind(this);
    this.handleAccountNumberChanged = this.handleAccountNumberChanged.bind(this);
    this.handleAddressChanged = this.handleAddressChanged.bind(this);
    this.handleCityStateChanged = this.handleCityStateChanged.bind(this);
    this.handleNameKeyChanged = this.handleNameKeyChanged.bind(this);
    this.handleServiceReferenceChanged = this.handleServiceReferenceChanged.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  public componentWillMount() {
    this.projectDocument = fs.fs.collection("projects").doc(this.props.match.params.id);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          const { account } = doc.data() as any;
          if (account) {
            this.setState({
              accountHolder: account.accountHolder ? account.accountHolder : "",
              accountNumber: account.accountNumber ? account.accountNumber : "",
              address: account.address ? account.address : "",
              cityState: account.cityState ? account.cityState : "",
              nameKey: account.nameKey ? account.nameKey : "",
              serviceReference: account.serviceReference ? account.serviceReference : "",
            });
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
      });
  }

  public render() {
    const { appService } = this.props;

    if (!appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    return (
      <div className="container flex-column">
        <AccountForm
          accountHolder={this.state.accountHolder}
          accountNumber={this.state.accountNumber}
          address={this.state.address}
          appService={this.props.appService}
          cityState={this.state.cityState}
          nameKey={this.state.nameKey}
          serviceReference={this.state.serviceReference}
          handleAccountHolderChanged={this.handleAccountHolderChanged}
          handleAccountNumberChanged={this.handleAccountNumberChanged}
          handleAddressChanged={this.handleAddressChanged}
          handleCityStateChanged={this.handleCityStateChanged}
          handleNameKeyChanged={this.handleNameKeyChanged}
          handleServiceReferenceChanged={this.handleServiceReferenceChanged}
          handleSave={this.handleSave}
          handleCancel={this.handleCancel}
        />
      </div>
    );
  }

  private handleAccountHolderChanged(value: string): void {
    this.setState({ accountHolder: value });
  }
  private handleAccountNumberChanged(value: string): void {
    this.setState({ accountNumber: value });
  }
  private handleAddressChanged(value: string): void {
    this.setState({ address: value });
  }
  private handleCityStateChanged(value: string): void {
    this.setState({ cityState: value });
  }
  private handleNameKeyChanged(value: string): void {
    this.setState({ nameKey: value });
  }
  private handleServiceReferenceChanged(value: string): void {
    this.setState({ serviceReference: value });
  }
  private handleSave() {
    this.setState({ loading: true });
    const account: IAccount = {
      accountHolder: this.state.accountHolder,
      accountNumber: this.state.accountNumber,
      address: this.state.address,
      cityState: this.state.cityState,
      nameKey: this.state.nameKey,
      serviceReference: this.state.serviceReference,
    };
    this.projectDocument
      .update({
        account,
      })
      .then(() => {
        this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
      });
  }
  private handleCancel() {
    this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/accounts/AccountPage.tsx